<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<h1>Introduction</h1>
<p></p>
<p>It all began on a small island located in South East Queensland, Australia, when four children, Dino, Tommy, Maria and Jake, have difficult starts in life and are offered a better life by Parlow the Pelican. Each child is given a magical seaweed necklace with a gold ingot and a secret code of silence written on it. The children must wear this ingot in order to enter the Enchanted Sea World that lies beneath Mangrove Sands. They enter this magical world through a tunnel dug out by soldier crabs where they discover a magical new world with animals and sea creatures who can talk and they soon become the children’s mentors, friends and family.</p>
<p>Every Friday evening for the past two years, the children are collected from their homes by Parlow and tutored by the Dugongs, Wally, Delilah and Pedro. They enjoy many adventures and mishaps including; nearly drowning in Ollie octopuses cave, being saved from a bull shark ride, fun times on the Seaweed Slide, operated by Mut and Tut turtle, Johanna’s Ferris Wheel ride, and enjoying delicious food and treats made by Ibis Chef.</p>
<p>They learn many human lessons and by the end of the year have transitioned from failing students to the top of their class.</p>
<p>Each year, one or more of the children must relinquish their ingots when they transition from primary school to high school and another child is offered the opportunity to join the Enchanted Sea World. Last year, an aboriginal girl named Wanjee joined the Enchanted Sea World and was given Dino’s ingot. Wanjee taught her friends about her culture and language and the children met Toddalick the magic frog, escaped bushfires on humpback whales, helped stop environmental disasters and learnt many more life lessons.</p>
<p>Tommy and Maria relinquished their ingots and transitioned to high schools located on the mainland, all except Jake and Wanjee who begin their final year at primary school.</p>
<p>With only two remaining ingots, Jake and Wanjee are excited to find out who Parlow will choose to join them in the Enchanted Sea World this year, but they will soon discover that one very unexpected person will be chosen.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?3dbb80d0